// extracted by mini-css-extract-plugin
export default {"card":"GridCard_card__ddG1C","icon":"GridCard_icon__1Lm8+","title":"GridCard_title__Xc3R6","range":"GridCard_range__Hs6wp"};